<template>
  <v-container fluid class="pa-0 consulta-credito-container">
    <!-- Header -->
    <div class="dashboard-header">
      <div class="header-content">
        <div class="d-flex align-center">
          <div class="icon-wrapper">
            <v-icon color="#023449" size="28">mdi-credit-card-check</v-icon>
          </div>
          <div class="ml-3">
            <h1 class="dashboard-title">Consulta de Limite de Crédito</h1>
            <p class="dashboard-subtitle">Análise de crédito baseada em dados do Serasa</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="dashboard-content">
      <ConsultaCredito />
    </div>
  </v-container>
</template>

<script>
import ConsultaCredito from './ConsultaCreditoLimite.vue';

export default {
  name: 'ConsultaCreditoContainer',

  components: {
    ConsultaCredito,
  },
};
</script>

<style scoped>
.consulta-credito-container {
  min-height: calc(100vh - 300px);
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 0 8px 8px 8px;
}

/* Header Section */
.dashboard-header {
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.header-content {
  flex: 1;
}

.icon-wrapper {
  background: linear-gradient(135deg, rgba(2, 52, 73, 0.08) 0%, rgba(2, 52, 73, 0.04) 100%);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #023449;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.dashboard-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0 0;
  font-weight: 400;
}

/* Content Area */
.dashboard-content {
  padding: 0;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade */
@media (max-width: 768px) {
  .dashboard-header {
    padding: 20px;
  }

  .dashboard-title {
    font-size: 1.25rem;
  }

  .dashboard-subtitle {
    font-size: 0.813rem;
  }
}

@media (max-width: 480px) {
  .dashboard-title {
    font-size: 1.125rem;
  }

  .icon-wrapper {
    padding: 10px;
  }

  .icon-wrapper >>> .v-icon {
    font-size: 24px !important;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .dashboard-content {
    animation: none !important;
  }
}
</style>